import React from "react";
import "./Blogs.css";
import Particles from "react-tsparticles";
import { useNavigate } from "react-router";
import { Card, Col, Row } from "react-bootstrap";
import { Button } from "bootstrap";
const Blogs = () => {
  const particlesInit = (main) => {
    console.log(main);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };
  const navigate = useNavigate();
  const goHome = () => {
    navigate("/Home");
  };
  return (
    <div className="blogs">
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          fpsLimit: 60,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                value_area: 800,
              },
              value: 40,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              random: true,
              value: 5,
            },
          },
          detectRetina: true,
        }}
      />

      <Row xs={1} md={3} className="g-4">
        <Col>
          <Card className="blogCard m-4">
            <Card.Img className="cardImg" variant="top" src="https://i.ibb.co/nLtqw77/redux.jpg" />
            <Card.Body>
              <Card.Title className="text-center">Redux toolkit</Card.Title>
              <Card.Text>
              I was too much curious to learn the redux state management system. Recently I have got knowledge about the redux toolkit. From now I will use the redux toolkit in my large project cause it is so good at state...<a target="_blank" href="https://medium.com/@iasir.arafat.riaz/redux-toolkit-newly-learn-9b615bdd1ac6">Reade More</a>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="blogCard m-4">
            <Card.Img className="cardImg" variant="top" src="https://i.ibb.co/2h7QtT1/1934362-ca3c.png" />
            <Card.Body>
              <Card.Title className="text-center">Socket.io</Card.Title>
              <Card.Text>
              A javascript library for making a real-time application known as Socket.io. It’s best for making our website real-time like we get our data without refreshing. It’s used by a lot of large companies....<a target="_blank" href="https://medium.com/@iasir.arafat.riaz/socket-io-1d3008fae573">Reade More</a>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* <div className="go-home">
            <button onClick={goHome} className="btn btn-danger "> Go Home</button>
            </div> */}
    </div>
  );
};

export default Blogs;
